import groupsApi from '@api/groupsApi';
import commonApi from '@api/commonApi';
import constants from './constants';

function requestGroups() {

  return (dispatch, getState) => {

    const { groups, groupsLoading } = getState().variables;
    if (groups || groupsLoading) return;

    dispatch({ type: constants.VARIBLES_GROUPS_LOADING });

    groupsApi
      .groups()
      .then((response) => {

        dispatch({
          type: constants.VARIABLES_SET_GROUPS,
          payload: response,
        });

      })
      .catch((resError) => {

        dispatch({
          type: constants.VARIABLES_GROUPS_ERROR,
          payload: resError,
        });

      });

  };

}

function addGroup(group) {

  return {
    type: constants.VARIABLES_GROUPS_ADD,
    payload: group,
  };

}

function setDefaultAlarms(defaultAlarms) {

  return {
    type: constants.VARIABLES_SET_DEFAULT_ALARMS,
    payload: defaultAlarms,
  };

}

function updateDefaultAlarm(alarm) {

  const { name } = alarm || {};
  if (!name) return;

  // eslint-disable-next-line consistent-return
  return (dispatch, getState) => {

    const { defaultAlarms } = getState().variables;
    const newDefaultAlarms = { ...defaultAlarms, [name]: alarm };
    dispatch({
      type: constants.VARIABLES_UPDATE_DEFAULT_ALARM,
      payload: newDefaultAlarms,
    });

  };

}

function requestAlarmsFields({ offset = 0, limit = 20 } = {}) {

  return (dispatch, getState) => {

    const { alarmsFields, alarmsFieldsLoading } = getState().variables;
    if (alarmsFields.next === null || alarmsFieldsLoading) return;

    dispatch({ type: constants.ALARMS_FIELDS_LOADING });
    const { next } = alarmsFields;

    commonApi
      .getAlarmsFields({ next, offset, limit })
      .then((response) => {

        const res = {
          count: response.lenght,
          next: null,
          results: response,
        };
        // eslint-disable-next-line max-len
        /* let res = {"count":39,"next":null,"previous":null,"results":[{"id":1,"name":"Message UUID","edge_name":null,"database_name":"uuid","type":"string","format":"128-bit UUID"},{"id":2,"name":"Timestamp","edge_name":"ts","database_name":"time","type":"datetime","format":"ISO 8601"},{"id":3,"name":"Device ID","edge_name":"dev","database_name":"device","type":"string","format":"6 CHARS"},{"id":4,"name":"Client ID","edge_name":"cid","database_name":"client","type":"string","format":"6 CHARS"},{"id":5,"name":"Vehicle Model","edge_name":"mod","database_name":"vehicle_model","type":"string","format":"7 CHARS"},{"id":6,"name":"License Plate","edge_name":"lic","database_name":"license_plate","type":"string","format":"6 CHARS"},{"id":7,"name":"Status","edge_name":"sta","database_name":"status","type":"string","format":"6 CHARS"},{"id":8,"name":"Voltage","edge_name":"vol","database_name":"voltage","type":"numeric","format":"FLOAT (2 decimal places)"},{"id":9,"name":"Current","edge_name":"cur","database_name":"current","type":"numeric","format":"FLOAT (2 decimal places)"},{"id":10,"name":"Speed","edge_name":"spe","database_name":"speed","type":"numeric","format":"INTEGER"},{"id":11,"name":"Accelerator","edge_name":"acc","database_name":"accelerator","type":"numeric","format":"FLOAT (1 decimal places)"},{"id":12,"name":"Brakes","edge_name":"bra","database_name":"brakes","type":"bool","format":"BOOLEAN"},{"id":13,"name":"State Of Charge","edge_name":"soc","database_name":"soc","type":"numeric","format":"FLOAT (1 decimal places)"},{"id":14,"name":"Odometer","edge_name":"odo","database_name":"odometer","type":"numeric","format":"FLOAT (2 decimal places)"},{"id":15,"name":"Latitude","edge_name":"lat","database_name":"location","type":"numeric","format":"FLOAT (6 decimal palces)"},{"id":16,"name":"Longitude","edge_name":"lon","database_name":"location","type":"numeric","format":"FLOAT (6 decimal places)"},{"id":17,"name":"Cell Voltage","edge_name":"cv","database_name":"cell_voltages","type":"array","format":"[ FLOAT (2 decimal places) ]"},{"id":18,"name":"Cell Temperatures","edge_name":"ct","database_name":"cell_temperatures","type":"array","format":"[ FLOAT (3 decimal places) ]"},{"id":19,"name":"Door Status","edge_name":"ds","database_name":"door_status","type":"bool","format":"BOOLEAN"},{"id":20,"name":"Extra Fields","edge_name":"ext","database_name":"extra","type":"json","format":"JSON"},{"id":21,"name":"Enqueued At (Cloud)","edge_name":null,"database_name":"enqueued_at","type":"datetime","format":"ISO 8601"},{"id":22,"name":"Processed At (Cloud)","edge_name":null,"database_name":"processed_at","type":"datetime","format":"ISO 8601"},{"id":23,"name":"GPRS Signal","edge_name":"sig","database_name":"gprs_signal","type":"numeric","format":"INTEGER"},{"id":24,"name":"GPS Accuracy","edge_name":"gac","database_name":"gps_accuracy","type":"numeric","format":"INTEGER"},{"id":25,"name":"Device Temperature","edge_name":"dte","database_name":"device_temperature","type":"numeric","format":"INTEGER"},{"id":26,"name":"Altitude","edge_name":"alt","database_name":"location","type":"numeric","format":"FLOAT (2 decimal places)"},{"id":27,"name":"Driving mode","edge_name":"mode","database_name":"drive_mode","type":"string","format":"3 CHARS"},{"id":28,"name":"Motor temp","edge_name":"mot","database_name":"motor_temperature","type":"numeric","format":"INTEGER"},{"id":29,"name":"Energy (journey/charging)","edge_name":"ene","database_name":"energy","type":"numeric","format":"FLOAT (2 DECIMAL PLACES)"},{"id":30,"name":"Hash ID","edge_name":"hid","database_name":"hash_id","type":"string","format":"12 CHAR"},{"id":31,"name":"Charge State","edge_name":"cst","database_name":"charge_state","type":"string","format":"3 CHARS"},{"id":32,"name":"Free SD Space","edge_name":"fsd","database_name":"free_memory_space","type":"numeric","format":"INTEGER"},{"id":33,"name":"Stand by time","edge_name":"sbt","database_name":"stand_by_time","type":"numeric","format":"INTEGER"},{"id":34,"name":"Min Cell Voltage","edge_name":"miv","database_name":"min_cell_voltage","type":"numeric","format":"FLOAT (2 DECIMAL PLACES)"},{"id":35,"name":"Max Cell Voltage","edge_name":"mav","database_name":"max_cell_voltage","type":"numeric","format":"FLOAT (2 DECIMAL PLACES)"},{"id":36,"name":"Min Cell Temperature","edge_name":"mit","database_name":"min_cell_temperature","type":"numeric","format":"SMALL INTEGER"},{"id":37,"name":"Max Cell Temperature","edge_name":"mat","database_name":"max_cell_temperature","type":"numeric","format":"SMALL INTEGER"},{"id":38,"name":"Average Cell Temperature","edge_name":"at","database_name":"avg_cell_temperature","type":"numeric","format":"SMALL INTEGER"},{"id":39,"name":"Energy regeneration","edge_name":"reg","database_name":"energy_regeneration","type":"numeric","format":"FLOAT (2 DECIMAL PLACES)"}]} */
        // eslint-disable-next-line no-shadow
        const { next, results } = res;
        dispatch({
          type: constants.ALARMS_FIELDS_SUCCESS,
          payload: { next, results },
        });

      })
      .catch((resError) => {

        // eslint-disable-next-line
        console.log(resError);
        dispatch({
          type: constants.ALARMS_FIELDS_ERROR,
          payload: resError,
        });

      });

  };

}

function addMaintenanceType(maintenanceType) {

  return {
    type: constants.VARIABLES_MAINTENANCE_TYPES_ADD,
    payload: maintenanceType,
  };

}

export default {
  requestGroups,
  addGroup,
  setDefaultAlarms,
  updateDefaultAlarm,
  requestAlarmsFields,
  addMaintenanceType,
};
